import React,{ useEffect,useState } from 'react';
import { Breadcrumb, Row, Col, Card,Form,Input,Select,Button, Space, message, Popconfirm } from 'antd';
import { useHistory } from "react-router";
import constants from "../../../constants/constants";
import { fetchAdminApi } from '../../../services/api';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../globalFunctions/AuthContext';
const EditAdmin =() => {
	const { user  } = useAuth();
	const history = useHistory();
	const [form] = Form.useForm();
	const { Option } = Select;
	const { TextArea } = Input;
	const storedData = JSON.parse(sessionStorage.getItem("editAdminData"));
	const [type] = useState(storedData?.type); 
	const [editAdminDetails] = useState(storedData?.adminRecords);
	const [statusType,setStatusType] = useState(1);
	const [adminType,setAdminType] = useState(2);
	const [passwordStatus,setPasswordStatus]=useState("");
	const [confirmPassword,setConfirmPassword]=useState("f");
	const location = useLocation(); 
	const isMyProfile = location.pathname === '/my-profile';
	const userId = user?.userId;
	useEffect(() => {
		if (type === 0 && editAdminDetails) {
			setEditAdminFormFields(editAdminDetails);
		} else {
			form.setFieldsValue({
				Status: 1,
				Type: 2
			});
		}
		if(isMyProfile){
			fetchAdminUser();
		}
	}, []);
	const fetchAdminUser = () => {
		let payload = { admin_id: userId };
		fetchAdminApi("/get-admin-details", "post", payload).then((res) => {
			if (res && res.data) {
				setEditAdminFormFields(res.data);
			} else {
				form.resetFields();
			}
		});
	};
	const horizontalLayout = {
		labelCol: { span: 8, },
		wrapperCol: { span: 16, },
	};
	const horizontalLayout2 = {
		labelCol: { span: 4, },
		wrapperCol: { span: 20, },
	};
	// const horizontalLayoutDetails = {
	// 	labelCol: { span: 3, },
	// 	wrapperCol: { span: 19, },
	// };
	//Function to validate password to check if it has 1 special character, 1 Upper case, 1 number and should have 14 characters and space are not allowed at the beginning and end of the password.
	const handlePasswordValidation = (rule, value, callback) => {
		try {
			if (!value) {
				setConfirmPassword("f");
				if(Number(type) !== 0){
					setPasswordStatus("error");
					throw new Error(constants.PasswordRegistration);
				}
			}
			const passwordValidate = /^(?=.{14,}$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s])[^\s].*[^\s]$/;
			if (!passwordValidate.test(value)) {
				setPasswordStatus("error");
				return callback(new Error(constants.PasswordValidation));
			}
			setConfirmPassword("t");
			setPasswordStatus("success");
			return callback();
		} catch (err) {
			return callback(err);
		}
	};
	const onFinalSave =(values)=>{
		let payload=null;
		let editPayload=null;
		payload={
			login_username:values.Username,
			user_firstname:values.FirstName,
			user_lastname:values.LastName,
			user_email:values.Email,
			type:values.Type,
			status:values.Status,
			details:values.Details,
			login_password:values.password,
			confirm_password:values.confirmPassword,
		};
		editPayload={
			login_username:values.Username,
			user_firstname:values.FirstName,
			user_lastname:values.LastName,
			user_email:values.Email,
			user_type:values.Type,
			is_active:values.Status,
			user_details:values.Details,
		};
		if(values.password){
			editPayload.login_password=values.password;
		}
		if(editAdminDetails || isMyProfile){
			editAdminUser(editPayload);
		}else{
			addAdminUser(payload);
		}
	};
	const addAdminUser =(payload)=>{
		fetchAdminApi(`/add_admin_user`, "post", payload).then(
			(res) => {
				if (res && res.code) {
					if (res.code === 200) {
						message.success(res.message);
						history.push({ pathname: "/admin-users" });
					} else {
						if(res.message){
							if (res.message.login_username) {
								message.error(res.message.login_username);
							}else if(res.message.user_email){
								message.error(res.message.user_email);
							}else{
								message.error(res.message);
							}
						}
					}
				}
			}
		);
	};
	const editAdminUser =(payload)=>{
		let adminId = editAdminDetails?.Admin_id ? editAdminDetails?.Admin_id : userId;
		fetchAdminApi(`/edit_admin_user/${adminId}`, "put", payload).then(
			(res) => {
				if (res && res.code) {
					if (res.code === 200) {
						message.success(res.message);
						sessionStorage.removeItem("editAdminData");
						let pathname;
						if(isMyProfile){
							pathname = "/admin-dashboard";
						}else{
							pathname = "/admin-users";
						}
						history.push({ pathname: pathname });
					} else {
						if(res.message){
							if (res.message.login_username) {
								message.error(res.message.login_username);
							}else if(res.message.user_email){
								message.error(res.message.user_email);
							}else{
								message.error(res.message);
							}
						}
					}
				}
			}
		);
	};
	const onchangeStatusType=(value)=>{
		setStatusType(value);
	};
	const onchangeAdminType=(value)=>{
		setAdminType(value);
	};
	const setEditAdminFormFields=(editAdminDetails)=>{
		form.setFieldsValue({
			Username:editAdminDetails &&editAdminDetails.Username,
			FirstName:editAdminDetails &&editAdminDetails.first_name ,
			Email:editAdminDetails &&editAdminDetails.Email,
			Status:editAdminDetails &&editAdminDetails.status =="Active"?1:0,
			LastName:editAdminDetails &&editAdminDetails.last_name,
			Type:editAdminDetails &&editAdminDetails.User_Type?parseInt(editAdminDetails.Usertype):1,
			Details:editAdminDetails &&editAdminDetails.Details
		});
	};
	const formFields = (name) =>{
		switch (name) {
		case "Username":
			return <Form.Item
				{...horizontalLayout}
				label={constants.Username}
				labelAlign="left"
				name="Username"
				rules={[
					{
						required: true,
						message: constants.UserNameRegistration,
					}, 
					{
						pattern: /^(?=.{2,})\S*$/,
						message: constants.UserNameRegistrationInvalid,
					}
				]}
			>
				<Input disabled={type == 0 || isMyProfile? true : false} placeholder={constants.Username}/>
			</Form.Item>;
		case "FirstName":
			return <Form.Item
				{...horizontalLayout}
				label={constants.FirstName}
				labelAlign="left"
				name="FirstName"
				rules={[
					{
						required: true,
						message: constants.FirstNameRegistration,
					}
				]}
			>
				<Input disabled ={isMyProfile?true:false} placeholder={constants.FirstName}/>
			</Form.Item>;
		case "Email":
			return <Form.Item
				{...horizontalLayout}
				label="Email"
				labelAlign="left"
				name="Email"
				rules={[
					{
						type: "email",
						message: constants.EmailNotValid,
					},
					{
						required: true,
						message: constants.EmailRegistration,
					},
				]}
			>
				<Input 
					disabled ={isMyProfile?true:false}
					placeholder={constants.Email}
				/>
			</Form.Item>;
		case "password":
			return <Form.Item
				{...horizontalLayout}
				name="password"
				label={constants.Password}
				labelAlign="left"
				validateStatus={passwordStatus}
				rules={[
					{
						required: type == 0?false:true,
						message: " ",
					},
					{ validator: handlePasswordValidation },
				]}
				hasFeedback
				tooltip={constants.PsdTip}
			>
				<Input.Password placeholder={constants.Password}/>
			</Form.Item>;
		case "Status":
			return <Form.Item
				{...horizontalLayout}
				labelAlign="left"
				label={constants.Status}
				name="Status"
			>
				<Select onChange={onchangeStatusType} value={statusType}>
					{/* <Option value={0}>Select</Option> */}
					<Option value={1}>Active</Option>
					<Option value={0}>Inactive</Option>
				</Select>
			</Form.Item>;
		case "LastName":
			return <Form.Item
				{...horizontalLayout}
				label={constants.LastName}
				labelAlign="left"
				name="LastName"
				rules={[
					{
						required: true,
						message: constants.LastNameRegistration,
					},
					{
						// pattern: /^[A-Za-z]+((\s)?((.)?([A-Za-z])+))*$/,
						pattern: /^[^0-9]*$/,
						message:
								constants.LastNameInvalid,
					},
				]}
			>
				<Input disabled={isMyProfile ? true : false} placeholder={constants.LastName}/>
			</Form.Item>;
		case "Type":
			return <Form.Item
				{...horizontalLayout}
				labelAlign="left"
				label={constants.Type}
				name="Type"
			>
				<Select onChange={onchangeAdminType} value={adminType}>
					{/* <Option value={0}>Select</Option> */}
					<Option value={1}>Admin</Option>
					<Option value={2}>Auditor</Option>
					<Option value={3}>Contributor</Option>
					<Option value={4}>Pro-Ed</Option>
				</Select>
			</Form.Item>;
		case "confirmPassword":
			return <Form.Item
				{...horizontalLayout}
				name="confirmPassword"
				label={constants.ConfirmPsd}
				labelAlign="left"
				dependencies={["password"]}
				hasFeedback
				rules={[
					{
						required: confirmPassword === "f"?false:true,
						message: constants.ConfirmPasswordRegistration,
					},
					({ getFieldValue }) => ({
						validator(_, value) {
							if (!value || getFieldValue("password") === value) {
								return Promise.resolve();
							}
							return Promise.reject(
								new Error(
									constants.PasswordNotMatch
								)
							);
						},
					}),
				]}
			>
				<Input.Password placeholder={constants.ConfirmPsd}/>
			</Form.Item>;
		case "Details":
			return <Form.Item
				{...horizontalLayout2}
				labelAlign="left"
				label={constants.Details}
				name="Details"
			>
				<TextArea rows={4} placeholder="Details"/>
			</Form.Item>;
		default:
			break;
		}
	};
	const myProfileLayout = () => {
		return  <>
			<Col span={12}>
				{formFields("Username")}
			</Col>
			<Col span={12}>
				{formFields("Email")}
			</Col>
			<Col span={12}>
				{formFields("FirstName")}
			</Col>
			<Col span={12}>
				{formFields("LastName")}
			</Col>
			<Col span={12}>
				{formFields("password")}
			</Col>
			<Col span={12}>
				{formFields("confirmPassword")}
			</Col>
		</>;
	};
	const adminEditLayout = () => {
		return <>
			<Col span={12}>
				{formFields("Username")}
				{formFields("FirstName")}
				{formFields("Email")}
				{formFields("password")}
			</Col>
			<Col span={12}>
				{ formFields("Status") }
				{formFields("LastName")}
				{ formFields("Type") }
				{formFields("confirmPassword")}
			</Col>
			<Col span={24}>
				{formFields("Details")}
			</Col>
			<Col span={4}></Col>
		</>;
	};
	const handleDelete = () => {
		let payload={ delete_admin: 1 };
		editAdminUser(payload);
	};
	return (
		<>
			<div className="div">
				{
					!isMyProfile ?
						<div className="p-3">
							<Breadcrumb>
								<Breadcrumb.Item ><a onClick={() => {
									history.push({ pathname: "/admin-dashboard" });
								}}>Home</a></Breadcrumb.Item>
								<Breadcrumb.Item><a onClick={() => { history.push("/admin-users"); }}>Admin Users</a></Breadcrumb.Item>
								<Breadcrumb.Item>{type == 0 ? "Edit Admin User" : "Add Admin User"}</Breadcrumb.Item>
							</Breadcrumb>
						</div>
						: null
				}
				<div>
					{/* <Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}> */}
					<Card bordered size="small" title={<span className="text-uppercase">{isMyProfile ?constants.MyProfileHeader:type == 0 ?"Edit Admin User":"Add Admin User"}</span>}>
						<Form form={form} onFinish={onFinalSave} >
							<Row gutter={24}>
								{
									isMyProfile ? 
										myProfileLayout():
										adminEditLayout()
								}
								<Col span={20}>
									<Form.Item 
									>
										<Space>
											<Button type="primary" htmlType="submit" className="navy-btn">{constants.Save}</Button>
											{
												isMyProfile ||  (userId ===  editAdminDetails?.Admin_id) || type !== 0 ? null :
													<Popconfirm
														okButtonProps={{
															type: "primary",
															className: "navy-btn"
														}} overlayClassName="custom-popconfirm" title={constants.ConfirmDelete} onConfirm={() => handleDelete()}>
														<Button type="primary" danger>Delete</Button>
													</Popconfirm>
											}
											<Button
												onClick={() => {
													sessionStorage.removeItem("editAdminData");
													history.push(isMyProfile ? "/admin-dashboard" : "/admin-users");
												}}
											>
												{constants.CancelBTN}
											</Button>
										</Space>
									</Form.Item>
								</Col>
								{/* <Col span={24} className="form-item-mb-3">
									<Form.Item
										className="label-width"
										labelAlign="left"
									>
										<Space>
											<Form.Item >
												<Button type="primary" htmlType="submit">Save</Button>
											</Form.Item>
											<Form.Item>
												<Button type="primary">Cancel</Button>
											</Form.Item>
										</Space>
									</Form.Item>
								</Col> */}
							</Row>
						</Form>
					</Card>
					{/* </Col>
					</Row> */}
				</div>
			</div>
		</>
	);
};
export default EditAdmin;